import { FC, useContext, useEffect, useState } from 'react';
import { ConsentContent } from 'templates/ConsentContent';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { GetAuditionResponse } from 'hooks/u002/useGetAuditionHooks';
import { AppContext } from 'templates/AppContextProvider';
import { useGetAgreementText } from 'hooks/u002/useGetAgreementTextHooks';
import LoadingModal from 'organisms/LoadingModal';
import MessageModal from 'organisms/MessageModal';
import { AppHeader } from 'templates/AppHeader';
import { AppFooter } from 'templates/AppFooter';
import { useAuditionTermsRegister } from 'hooks/u002/useAuditionTermsRegisterHooks';

//U002F04 特定利用同意画面
type SpecificUseConsentProps = {
  audition: GetAuditionResponse & {
    audition_id: string;
  };
  onNext: () => void;
};
export const SpecificUseConsent: FC<SpecificUseConsentProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const [checked, setChecked] = useState(false);
  const { userId } = useContext(AppContext);
  const { audition, onNext } = props;
  const { currentLang } = useContext(AppContext);
  const [termRegister, termLoading] = useAuditionTermsRegister();
  const [errorMessage, setErrorMessage] = useState('');
  const [specificUseConsent, loading, err] = useGetAgreementText({
    user_id: userId,
    audition_id: audition.audition_id,
    examination_no: audition.examination_no,
    lang: currentLang,
    consent_type: '2', // 2: 特定利用同意
  });
  useEffect(() => {
    if (err?.message) {
      setErrorMessage(tAuditionForm('TU002_050'));
    }
  }, [err]);

  const handleNext = () => {
    console.log(audition);
    console.log(userId);
    // 特定利用同意API送信
    termRegister({
      request: {
        user_id: userId,
        audition_id: audition.audition_id,
        revision: specificUseConsent?.revision ?? '',
        consent_type: '2', // 2: 特定利用同意
      },
      onSuccess: () => {
        onNext();
      },
      onError: (err) => {
        console.log(err);
        setErrorMessage(tAuditionForm('TU002_050'));
      },
    });
  };

  const handleChange = (checked: boolean) => {
    setChecked(checked);
  };

  return (
    <>
      {(loading || termLoading) && <LoadingModal />}
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tAuditionForm('TU002_032')}
          onClose={() => setErrorMessage('')}
        />
      )}
      <AppHeader />
      <ConsentContent
        title={tAuditionForm('TU002_007')}
        text={specificUseConsent?.consent_text}
        label={tAuditionForm('TU002_046')}
        nextLabel={tAuditionForm('TU002_047')}
        backLabel={tAuditionForm('TU002_048')}
        checked={checked}
        onChange={handleChange}
        onNext={handleNext}
      />
      <AppFooter />
    </>
  );
};
